import { Injectable } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { UserService } from '../../../operator/user-service/user.service';
import { MultiBuyerCmp } from '../../interfaces/company.interface';
import { CompanyService } from '../company/company.service';

@Injectable({
  providedIn: 'root',
})
export class MultiBuyerService {
  constructor(
    private readonly _userService: UserService,
    private readonly _companyService: CompanyService,
    private readonly _auth: AuthService
  ) {}

  public async selectBuyerPromise(
    cmpId: number,
    buyerCompanyId: number
  ): Promise<MultiBuyerCmp> {
    try {
      const buyersCmps = await this._companyService
        .getMultiBuyerCmpsList(cmpId, buyerCompanyId)
        .toPromise();

      if (!buyersCmps || buyersCmps.length === 0) {
        throw new Error('No company found.');
      }

      const selectedCompany = buyersCmps[0];

      const tokenResponse = await this._userService
        .getToken(selectedCompany.apiUserId, false)
        .toPromise();

      if (tokenResponse) {
        const multiBuyerCmpAuth = {
          ...tokenResponse,
          ...selectedCompany,
          parentCompany: cmpId,
        };

        this._auth.setSelectedMultiBuyerCompanyData(
          multiBuyerCmpAuth,
          selectedCompany.id
        );
      }
      return selectedCompany;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  public getMultiBuyerCmpsListPromise(cpmId: number, buyerCompanyId?: number) {
    return this._companyService
      .getMultiBuyerCmpsList(cpmId, buyerCompanyId)
      .toPromise();
  }

  public resetBuyerToken(): void {
    this._auth.resetMultiBuyerToken();
  }
}
